module.exports = __webpack_public_path__ + "static/img/1057_small.ec42c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1057_small.png
// module id = VBc1
// module chunks = 1